import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const emptyValue = { title: "", subject: "", text: "" };

const ConfirmationEmailModal = ({ isOpen, onClose, initialValue, onSave }) => {
  const [value, setValue] = useState(emptyValue);
  const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isOpen) return;

    const v = initialValue || emptyValue;
    setValue(v);
    setError("");

    if (v.text) {
      const blocksFromHtml = htmlToDraft(v.text);
      const { contentBlocks, entityMap } = blocksFromHtml;
      const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
      setEditorState(EditorState.createWithContent(contentState));
    } else {
      setEditorState(EditorState.createEmpty());
    }
  }, [isOpen, initialValue]);

  const handleChange = (e) => {
    const { name, value: v } = e.target;
    setValue((prev) => ({ ...prev, [name]: v }));
  };

  const handleSave = () => {
    const text = draftToHtml(convertToRaw(editorState.getCurrentContent()));

    // if (!value.title.trim()) return setError("Please enter a title");
    if (!value.subject.trim()) return setError("Please enter a subject");
    if (!editorState.getCurrentContent().hasText()) return setError("Please enter the email text");

    onSave({ ...value, text });
    onClose();
  };

  const labelStyle = { display: "block", marginBottom: "6px", fontSize: "14px", fontWeight: "600", color: "rgb(77, 0, 77)" };
  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    border: "2px solid rgb(77, 0, 77)",
    borderRadius: "8px",
    fontSize: "14px",
    boxSizing: "border-box",
    color: "black",
  };

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg" centered>
      <ModalHeader toggle={onClose} style={{ color: "#fff" }}>
        Confirmation Email Setup
      </ModalHeader>
      <ModalBody style={{ maxHeight: "70vh", overflowY: "auto" }}>
        {/* <div style={{ marginBottom: "16px" }}>
          <label style={labelStyle}>Title*</label>
          <input
            type="text"
            name="title"
            value={value.title}
            onChange={handleChange}
            placeholder="Enter email title"
            style={inputStyle}
          />
        </div> */}
        <div style={{ marginBottom: "16px" }}>
          <label style={labelStyle}>Subject*</label>
          <input
            type="text"
            name="subject"
            value={value.subject}
            onChange={handleChange}
            placeholder="Enter email subject"
            style={inputStyle}
          />
        </div>
        <div>
          <label style={labelStyle}>Body*</label>
          <div className="confirmation-email-editor" style={{ border: "1px solid rgb(77, 0, 77)", borderRadius: "4px" }}>
            <style>{`
              .confirmation-email-editor .confirmation-email-editor-toolbar {
                border: none;
                border-bottom: 1px solid #e9d5ff;
                margin-bottom: 0;
              }
              .confirmation-email-editor .confirmation-email-editor-body {
                min-height: 120px;
                max-height: 160px;
                overflow-y: auto;
                padding: 0 10px;
              }
            `}</style>
            <Editor
              editorState={editorState}
              onEditorStateChange={setEditorState}
              wrapperClassName="confirmation-email-editor-wrapper"
              editorClassName="confirmation-email-editor-body"
              toolbarClassName="confirmation-email-editor-toolbar"
            />
          </div>
        </div>

        {error && (
          <div style={{ color: "red", fontSize: "12px", marginTop: "10px" }}>
            {error}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <button className="btn-secondary" onClick={onClose}>
          Cancel
        </button>
        <button className="btn-primary" onClick={handleSave}>
          Save
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmationEmailModal;
